import { useQuery } from "@tanstack/react-query";
import stageService from "../api/stageService";

export const useStages = (boardId) => {
  const { getStages } = stageService();

  return useQuery({
    queryKey: ["get-stages", boardId],
    queryFn: async () => {
      const res = await getStages(boardId);
      return res.data;
    },
    enabled: !!boardId,
  });
};
